import { CSSObject } from '@emotion/react';
import { StyleSystemProp, createResponsiveStyles, useHoneycombTheme } from '../../theming';

function getImageStyles(islazy: boolean) {
    return (backgroundImage: React.CSSProperties['backgroundImage']) => {
        if (islazy) {
            // The `data-intersected` attribute will be set by LazyImageProvider.
            return {
                '&[data-intersected]': {
                    backgroundImage,
                },
            };
        }
        return {
            backgroundImage,
        };
    };
}

export interface BackgroundImageStylesParams {
    backgroundImage: StyleSystemProp<React.CSSProperties['backgroundImage']>;
    isLazy: boolean;
}

type StyleClasses = 'root';

export function useStyles({ backgroundImage, isLazy }: BackgroundImageStylesParams): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();

    const root: CSSObject = {
        ...createResponsiveStyles(
            [
                {
                    value: backgroundImage,
                    getStyles: getImageStyles(isLazy),
                },
            ],
            theme
        ),
    };

    return {
        styles: {
            root,
        },
    };
}
